//all image path
//----home page----------
export const homepage_offer_image = 'https://api.skycars.in/UploadedFiles/HomeDiscountIcon';
export const why_choose_cars_image = 'https://api.skycars.in/UploadedFiles/WhyChooseCarIcon';
export const how_it_work_image = 'https://api.skycars.in/UploadedFiles/HowItWorkIcon';

//----about us------
export const our_value_image = 'https://api.skycars.in/UploadedFiles/OurValueIcon';
export const about_banner_image = 'https://api.skycars.in/UploadedFiles/Banner';